module.exports = __webpack_public_path__ + "img/undraw_empty.b1c18453.svg";